export const ROAST_GAMES = {
  'bad-resume-1': { // Key maintained to preserve routing stability
    id: "game_resume_roaster",
    title: "Outbound Comms Audit",
    baseTotalErrors: 3,
    
    preGameBriefing: {
        title: "The Send Button is Final",
        script: "Attention to detail isn't about perfect spelling; it's about mitigating enterprise risk. The Mission: We've intercepted an outbound communication. Tap to flag the 3 critical errors before the message is sent. Be precise. If you flag correct data, you drain your mistake budget.",
        videoUrl: null
    },

    failureLogic: {
        'out_of_taps': {
            title: "Precision Matters",
            script: "You clicked wildly and ran out of mistake budget. In the enterprise, 'guessing' is dangerous. Slow down and validate the error before you flag it.",
            videoUrl: null
        }
    },

    // DYNAMIC CONTENT POOL (High Stakes Emails)
    variants: [
        {
            id: 'variant_client_email',
            context: "Drafting a high-stakes campaign update to a Tier-1 Client (Acme Corp).",
            documentText: [
              { id: 't1', text: 'To: Acme Corp Marketing Team\n' },
              { id: 't2', text: 'Subject: Q3 Campaign Update\n\n' },
              { id: 't3', text: 'Hi everyone,\n\n' },
              { id: 't4', text: 'I wanted to share the stellar results we achieved ' },
              { id: 'err_client', text: 'for Globex this quarter.', isError: true, feedback: 'Wrong Client Name! You copy-pasted a template and forgot to change the name. Instant loss of trust.' },
              { id: 't5', text: ' As you can see in the attached report, our conversion rate increased by 14%.\n\n' },
              { id: 't6', text: 'We believe this data supports increasing the ad spend for Q4. ' },
              { id: 'err_attachment', text: 'Please review the attached invoice to proceed.', isError: true, feedback: 'Missing Attachment: You referenced an invoice but didn\'t attach it. Sloppy.' },
              { id: 't7', text: '\n\n' },
              { id: 'err_replyall', text: '[CC: All Internal Company Employees]', isError: true, feedback: 'Reply-All Disaster: Never CC the entire company on an external client email.' },
              { id: 't8', text: '\n\nBest,\nMark' }
            ]
        },
        {
            id: 'variant_internal_finance',
            context: "Sending an urgent Q4 Financial Update to the Board of Directors.",
            documentText: [
              { id: 't1', text: 'To: Board of Directors\n' },
              { id: 't2', text: 'Subject: Q4 Final Revenue Numbers\n\n' },
              { id: 't3', text: 'Board Members,\n\n' },
              { id: 't4', text: 'We closed the quarter strong. ' },
              { id: 'err_math', text: 'Total revenue hit $1.2M, which is a 50% decrease from last quarter\'s $800k.', isError: true, feedback: 'Math Error: $1.2M is an INCREASE from $800k. Basic math errors destroy executive credibility.' },
              { id: 't5', text: ' Customer churn stabilized at 4%.\n\n' },
              { id: 'err_pii', text: 'Our biggest lost account was John Smith (Acct: 4029-1928-4921-0012).', isError: true, feedback: 'PII Leak: You just exposed a plaintext credit card/account number in a mass email.' },
              { id: 't6', text: '\n\n' },
              { id: 'err_typo', text: 'We look forward to executing the stratagy next year.', isError: true, feedback: 'Spelling Error: "Stratagy" in a Board email is unacceptable.' },
              { id: 't7', text: '\n\nRegards,\nThe Executive Team' }
            ]
        }
    ]
  }
};